import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ModelMappingEditor } from "@/components/ModelMappingEditor";

type Props = {
  models: string | null;
  modelMapping: string | null;
  onModelsChange: (value: string | null) => void;
  onModelMappingChange: (value: string | null) => void;
  inheritedModels?: string;
  inheritedModelMapping?: string;
  inheritable?: boolean;
};

function modelsOf(csv: string): string[] {
  return csv.split(",").map((v) => v.trim()).filter(Boolean);
}

function normalizeInput(value: string): string | null {
  const trimmed = value.trim();
  return trimmed === "" || trimmed === "{}" || trimmed === "null" ? null : value;
}

export function InheritedModelConfigEditor({
  models,
  modelMapping,
  onModelsChange,
  onModelMappingChange,
  inheritedModels = "",
  inheritedModelMapping = "",
  inheritable = true,
}: Props) {
  const modelsValue = models ?? "";
  const mappingValue = modelMapping ?? "";
  const effectiveModels = modelsValue.trim() !== "" ? modelsValue : inheritedModels;
  const effectiveMapping = mappingValue.trim() !== "" ? mappingValue : inheritedModelMapping;
  const modelsHint = inheritable
    ? `留空 = 继承上级：${inheritedModels || "空"}`
    : "留空 = 不下发模型";
  const mappingHint = inheritable
    ? `留空 = 继承上级：${inheritedModelMapping || "无映射"}`
    : "留空 = 无映射";

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4">
        <div className="space-y-1.5">
          <Label>模型列表（逗号分隔）</Label>
          <Input
            value={modelsValue}
            onChange={(e) => onModelsChange(normalizeInput(e.target.value))}
            placeholder={inheritable ? `留空继承：${inheritedModels || "空"}` : "gpt-4o,gpt-4o-mini"}
          />
          <p className="text-[11px] text-muted-foreground">{modelsHint}</p>
        </div>
        <div className="space-y-1.5">
          <Label>Model Mapping</Label>
          <ModelMappingEditor
            value={mappingValue}
            sourceModelOptions={modelsOf(effectiveModels)}
            targetModelOptions={modelsOf(effectiveModels)}
            onChange={(value) => onModelMappingChange(normalizeInput(value))}
          />
          <p className="text-[11px] text-muted-foreground">{mappingHint}</p>
          {inheritable && effectiveMapping !== "" && mappingValue.trim() === "" && (
            <p className="text-[11px] text-muted-foreground">当前继承有效值：{effectiveMapping}</p>
          )}
        </div>
      </div>
    </div>
  );
}
